import CircularProgress from '@mui/material/CircularProgress';
import { LoadingWrapper } from "./styled"

const Loading = () => {

    return (
        <LoadingWrapper>
            <div className="loading_main">
                <div
                    className="loading_icon"
                >
                    <CircularProgress />
                    <p>Loading...</p>
                </div>
            </div>
        </LoadingWrapper>
    );
}

export default Loading;
